module.exports = __webpack_public_path__ + "static/media/modal-avatar.60bf8ffd.png";